angular.module 'zc.commonApi'

# Textual search for filters
# if string is present in apikey or name

.filter 'campaignText', ->
  (campaigns, search) ->

    result = _.filter campaigns, (campaign) ->
      return true unless search

      conditions = [
        campaign.project_name
        campaign.apikey
        campaign.status
        campaign.campaign_device
        campaign.name
        campaign.id
        campaign.elements?[0]?.id
        campaign.template_type
        campaign.campaign_target
        campaign.campaign_policy_set?.name
      ]

      # check if every keyword meets all condition
      keywords = search.split /\s/
      _.every keywords, (keyword) ->

        # check if keyword meets ANY condition
        _.some conditions, (condition) ->
          condition = condition + '' if typeof condition isnt 'string'
          return true if condition && condition.indexOf(keyword) > -1
          false

    result



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/filters/campaign_text_filter.js.coffee